import { createApp } from 'vue'
import App from './App.vue'
import './styles.css'
import './legacy.css'
import './theme.css'

createApp(App).mount('#app')
